import { SnailyError } from './SnailyError'

export class InvalidOperationError extends SnailyError {
	constructor(message: string, metadata?: unknown) {
		super(message, metadata)
		this.name = 'InvalidOperationError'

		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, InvalidOperationError)
		}
	}
}
